import { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { signOutAndReload } from '../lib/session';
import { useTranslation } from 'react-i18next';

// ─── Pantalla de espera de la sesión ────────────────────────────────────────
// Se muestra mientras la autenticación y la membresía se resuelven.
//
// POR QUÉ NO ES UN SPINNER A SECAS: si la resolución no termina nunca — el
// listener de auth que no dispara, una lectura de membresía que cuelga — el
// usuario queda frente a un spinner eterno sin nada que hacer. Es el mismo
// patrón que dejó al director afuera de sebex.cl: el sistema no sabía, y en vez
// de decirlo, se comportó como si supiera.
//
// A los STALL_MS aparece la salida. "Reintentar" sirve si fue transitorio; si el
// problema es el estado de la sesión, reintentar falla igual y deja al usuario
// en un bucle — por eso CERRAR SESIÓN tiene que estar disponible: es la única
// salida real cuando lo que está roto es la sesión misma.

const STALL_MS = 8000;

export function AuthLoadingScreen() {
  const { t } = useTranslation('common');
  const [stalled, setStalled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setStalled(true), STALL_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#0d1117',
        px: 3,
      }}
    >
      {!stalled ? (
        <CircularProgress sx={{ color: '#6366f1' }} />
      ) : (
        <Stack spacing={2} alignItems="center" sx={{ maxWidth: 420, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ color: '#e6edf3' }}>
            {t('authStall.title')}
          </Typography>
          <Typography variant="body2" sx={{ color: '#8b949e' }}>
            {t('authStall.body')}
          </Typography>
          <Stack direction="row" spacing={1.5}>
            <Button variant="contained" onClick={() => window.location.reload()}>
              {t('authStall.retry')}
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              sx={{ color: '#8b949e', borderColor: '#30363d' }}
              onClick={() => {
                void signOutAndReload();
              }}
            >
              {t('authStall.signOut')}
            </Button>
          </Stack>
        </Stack>
      )}
    </Box>
  );
}
